import { useZustand } from '../hooks/useZustand'
import { useGraphStore } from '../stores/useGraphStore'
import { useFilterStore } from '../stores/useFilterStore'
import { fetchRecalculatedGraphTopics } from '../hooks/useApi'
import { formatTopicsFromClusters } from './graphTopics'

/**
 * Sibling of loadGraphData.js's ai topic-apply wiring.
 * SHOUlD BE UNIFIED with loadGraphData.js
 */
export const applyAiTopicsToActiveGraph = async ({
    contextName,
    userName = null,
}) => {
    let data
    try {
        data = await fetchRecalculatedGraphTopics(contextName, [], [], userName)
    } catch (error) {
        console.error('[applyAiTopicsToActiveGraph] fetch failed:', error)
        return
    }

    if (useZustand.getState().currentContext !== contextName) {
        return
    }

    const topicsExtension = data?.topicsExtension
    if (!topicsExtension) return

    useGraphStore.getState().applyTopicsExtension(topicsExtension)

    const updatedClusters =
        useGraphStore.getState().graphData?.entriesAndGraphOfContext?.graph
            ?.graphologyGraph?.attributes?.top_clusters || []

    if (updatedClusters.length === 0) return

    const formattedTopics = formatTopicsFromClusters(updatedClusters)
    useZustand.getState().setTopics(formattedTopics, true)
    useFilterStore.getState().updateFilteredStatementsWithCommunities()
}
